import { DataSource, Layout, Tab, Tabset } from "@mcleod/components";

export abstract class AutogenLayoutCarrierSalesBoardMultiProfile extends Layout {
    layoutCarrierSalesBoard: Layout;
    sourceCarrierSalesProfile: DataSource;
    tabProfile: Tab;
    tabsetCarrierSalesProfiles: Tabset;
}
